import SiafLiteApiRepository from "../../external/siafLiteApi";

class MdfeNfsSaidaService {
  constructor() {
    this.urlBase = "/faturamento/mdfe-nf-saida";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }
}

export default MdfeNfsSaidaService;
